module.exports = __webpack_public_path__ + "img/Paris-normandie_0.f6725518.png";